import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography
} from '@mui/material'

interface IRoleDeleteModal {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  itemName: string
  memberCount?: number
}

export const RoleDeleteModal = (props: IRoleDeleteModal) => {
  const { open, onClose, onConfirm, itemName, memberCount = 0 } = props

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title">Confirmar exclusão</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Tem certeza que deseja excluir o cargo &quot;{itemName}&quot;?
          {memberCount > 0 && (
            <Typography color="error" variant="body2" sx={{ mt: 1 }}>
              Atenção: Este cargo possui {memberCount} membro(s) associado(s).
            </Typography>
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancelar
        </Button>
        <Button onClick={onConfirm} color="error" autoFocus>
          Excluir
        </Button>
      </DialogActions>
    </Dialog>
  )
}
